<template>
<div class="slider">
      <div class="controls" id="arrows-controls" aria-label="Carousel Navigation" tabindex="0">
        <a class="prev" data-controls="prev" aria-controls="customize" tabindex="-1">
            <i class="angle left icon"></i>
        </a>
        <a class="next" data-controls="next" aria-controls="customize" tabindex="-1">
            <i class="angle right icon"></i>
        </a>
    </div>
<tiny-slider :mouse-drag="true" :nav="true" :controls="true" :autoplayButtonOutput="false" autoplay :controlsContainer="'#arrows-controls'">
  <div v-for="slide in slider" :style="{ 'background-image': 'url(' + slide.image + ')' }" >
<div class="ui container item">
  <zo-agendamento></zo-agendamento>
  <div class="alinha-texto" v-if="slide.titulo != null">
    <h2 class="ui header">
  <div class="content" >
    {{slide.titulo}}
<div class="sub header">{{slide.subtitle}}</div>
  </div>
<div class="icone"></div>
</h2>
</div>
</div>
</div>
</tiny-slider>
</div>

</template>

<script>
import VueTinySlider from 'vue-tiny-slider';
import Agendamento from "../components/Agendamento";

  export default {
    components: {
          'tiny-slider': VueTinySlider,
          'zo-agendamento': Agendamento
            

    },
    data() { return {
        slider: [
    
             { 
            image: require('../assets/images/slider2.jpg'),
            agendamento: true
         }
    
        ]
    }}
  }
</script>
<style lang="scss">
@import url('../assets/sass/slider.css');

.slider {
    position: relative;
    outline: none;
.tns-nav {
  z-index: 60 !important;
    display: flex !important;
    justify-content: center !important;
    position: absolute !important;
    bottom:2rem;
    outline: none;
    width: 100% !important;
        button {
        background: rgba(0,194,130,0.21);
        border: 0px;
        padding: 0.18rem 0.8rem;
        margin: 0 0.5rem;
        &:hover {
        background: rgba(13,134,94,0.3);
        }
    }
}
.tns-nav-active {
          background: rgba(13,134,94,0.6) !important;
}
.tns-item {
  font-size: 3rem;
  font-family: Arial;
  position: relative;
  background-size: cover;
}
.item {
  height: auto;
  padding: 4rem 0;
  .icone {
    font-family: 'Icons';
    content: '\f5c9';
    font-size: 2rem;
  }
  &.ui.container {
    right: 0;
    left: 0;
    display: flex;
  }
  }
.alinha-texto{
      margin: auto 0;
      margin-left: auto;
      text-align: right;
      .header {
        font-size: 2rem;
        color:#00c07f;
        font-weight: bold;
      }
      &.sub {
          font-size: 0.9rem;
          color: #89949b;
          font-weight: normal;
    }.slider {
    height: 55vh;
    position: relative;
}}
#arrows-controls {
    height: auto;
    top: 25vh;
    display: flex;
    position: absolute;
    width: 100%;
    z-index: 22;
    outline: none;
    justify-content: space-between;
    a {
          outline: none;
            position: relative;
            margin: auto 2rem;
            cursor: pointer;
            background: hsla(160,100%,38%,0.09);
            border: 0;
            color: rgba(20,136,98,0.44);
            white-space: nowrap;
            padding: 0.5rem;
            border-radius: 50rem;
            &:hover {
            background: #00c282;
            color: #fff;
            }
            .icon {
            margin: 0;
            padding: 0;
        }
    }
}
}
</style>
